import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Form, Input, Button, message, Result } from 'antd'
import { tokens } from '../theme/tokens'
import './Auth.css'

export default function ResetPassword() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  const navigate = useNavigate()
  const [msg, contextHolder] = message.useMessage()
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  if (!token) {
    return (
      <div className="auth-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: tokens.colors.background }}>
        <Result
          status="error"
          title="无效的重置链接"
          subTitle="链接缺少必要参数，请重新申请密码重置。"
          extra={<Button type="primary" onClick={() => navigate('/forgot-password', { replace: true })}>重新申请</Button>}
        />
      </div>
    )
  }

  if (success) {
    return (
      <div className="auth-page" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: tokens.colors.background }}>
        <Result
          status="success"
          title="密码已重置"
          subTitle="请使用新密码登录系统。"
          extra={<Button type="primary" onClick={() => navigate('/login', { replace: true })}>前往登录</Button>}
        />
      </div>
    )
  }

  const onFinish = async (values: { password: string }) => {
    setLoading(true)
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: values.password }),
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({ detail: '重置失败' }))
        throw new Error(err.detail)
      }
      setSuccess(true)
    } catch (e: any) {
      msg.error(e.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page" style={{
      display: 'flex', justifyContent: 'center', alignItems: 'center',
      minHeight: '100vh', background: tokens.colors.background,
    }}>
      {contextHolder}
      <div className="auth-card" style={{
        width: 400, padding: 40,
        background: tokens.colors.surface,
        borderRadius: tokens.radius.xl,
        border: `1px solid ${tokens.colors.border}`,
        boxShadow: tokens.shadows.card,
      }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{
            fontSize: 28, fontWeight: 700, margin: 0,
            background: tokens.gradients.heading,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>
            ApexTribe
          </h1>
          <p style={{ color: tokens.colors.textMuted, marginTop: 8 }}>
            设置新密码
          </p>
        </div>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="password"
            label="新密码"
            rules={[{ required: true, message: '请输入新密码' }, { min: 6, message: '密码至少6位' }]}
          >
            <Input.Password size="large" placeholder="请输入新密码" />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="确认密码"
            dependencies={['password']}
            rules={[
              { required: true, message: '请确认密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('password') === value) return Promise.resolve()
                  return Promise.reject(new Error('两次密码不一致'))
                },
              }),
            ]}
          >
            <Input.Password size="large" placeholder="请再次输入密码" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 8 }}>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              重置密码
            </Button>
          </Form.Item>
        </Form>

        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Link to="/login" style={{ fontSize: 13, color: tokens.colors.textMuted, textDecoration: 'none' }}>
            返回登录
          </Link>
        </div>
      </div>
    </div>
  )
}
